import { AnyAction, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';

import { appSlice } from ".";
import { api } from "../api";
import { TypedUseSelectorHook } from "react-redux";

const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (_) => {
    const action = _ as AnyAction;

    const getErrorMessage = () => {
      if (action.payload?.data?.error) {
        return `${action.payload.data.error}: ${
          action.payload.data.message || ""
        }`;
      }

      return "Internal Server Error";
    };

    if (action.error?.message && action.payload?.data?.statusCode) {
      toast.error(getErrorMessage(), { toastId: "error" });
    }

    return next(action);
  };

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([api.middleware, rtkQueryErrorLogger]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
